import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VueResource from "vue-resource"
import colors from 'vuetify/es5/util/colors'
import 'material-design-icons/iconfont/material-icons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
// import 'font-awesome/css/font-awesome.min.css'
// import 'font-awesome/css/font-awesome.css'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(VueResource)
Vue.use(Vuetify, {
  theme: { 
    primary: colors.red,
    secondary: colors.blue.lighten2,
    nav: "#364150",
    background: "#1976D2",
    background2: '#e0dccc',
    accent: colors.shades.black,
    error: colors.red.accent3,
    info: '#2196F3',
    success: '#4CAF50', 
    warning: '#FFC107'
  }
})  
export default new Vuetify({
  icons: {
    iconfont: 'mdi', 
  },
  theme: {
    themes: {
      light: {
        primary: "#7ea684",
        secondary: "#cd7b78",
        accent: colors.shades.black,
        error: colors.red.accent3,
        b1:"#efeada",
        b2:"#e0dccc",
        b3:"#665c5b",
        f1:"#999999"
      },
      dark: {
        primary: colors.blue.lighten3,
      },
    },
  },
});
